import {
  Show,
  useShowContext,
  usePermissions,
} from "react-admin";

import { useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { apiUrl } from "../apiendpoint";


const QuestionShowInner = () => {
  const { record, isLoading } = useShowContext();

  const [tab, setTab] = useState(0);
  const [categories, setCategories] = useState([]);
  const [categoryBlocks, setCategoryBlocks] = useState([]);
  const [question, setQuestion] = useState(null);

  /* FETCH CATEGORIES */
useEffect(() => {
const token = localStorage.getItem("access_token");
  fetch(`${apiUrl}categories`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then(res => res.json())
    .then(data => setCategories(data || []))
    .catch(console.error);
}, []);

  /* PREFILL */
  useEffect(() => {
    if (!record || categories.length === 0) return;

    const blocks = (record.assessment_category_ids || []).map(id => {
      const sub = categories.find(c => Number(c.id) === Number(id));
      return sub
        ? {
            category: sub.category_name,
            subcategory: sub.subcategory_name,
          }
        : { category: "", subcategory: "" };
    });

    setCategoryBlocks(blocks);

    setQuestion({
      title: record.question_data?.question_text || "",
      marks: record.question_data?.marks || 0,
      difficulty: record.difficulty_level || "easy",
      options: record.question_data?.options || [],
      correct: record.question_data?.answer?.correct_option || "",
    });

  }, [record, categories]);

  if (isLoading || !question) return <div>Loading...</div>;

  return (
    <Box sx={{ maxWidth: "900px" }}>

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs value={tab} onChange={(e, v) => setTab(v)}>
          <Tab label="CATEGORY" />
          <Tab label="QUESTION" />
        </Tabs>
      </Box>

      {tab === 0 && (
        <Box>
          <h2>Categories</h2>

          {categoryBlocks.map((block, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                gap: 2,
                mb: 2,
              }}
            >
              <Box
                sx={{
                  padding: "10px",
                  minWidth: "250px",
                  height: "60px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {block.category}
              </Box>

              <Box
                sx={{
                  padding: "10px",
                  minWidth: "250px",
                  height: "60px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {block.subcategory}
              </Box>
            </Box>
          ))}
        </Box>
      )}

      {tab === 1 && (
        <Box>
          <Box
            sx={{
              p: 3,
              border: "1px solid #333",
              borderRadius: "50px",
              mb: 3,
            }}
          >
            <h2>Question</h2>

            <div
              dangerouslySetInnerHTML={{ __html: question.title }}
              style={{
                border: "1px solid #ccc",
                padding: "10px",
                borderRadius: "6px",
                minHeight: "100px",
                marginBottom: "20px",
              }}
            />

            <Box sx={{ mb: 2 }}>
              <strong>Marks:</strong> {question.marks}
            </Box>

            <Box sx={{ mb: 2 }}>
              <strong>Difficulty:</strong> {question.difficulty}
            </Box>

            <h3>Options</h3>

            {question.options.map((opt, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  mb: 1,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  {opt}
                </Box>

                {opt === question.correct && (
                  <span style={{ color: "green", fontWeight: "bold" }}>
                    ✔ Correct
                  </span>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};


/* ONLY CHANGE IS HERE */
const QuestionShow = (props) => {
  const { permissions = [] } = usePermissions();

  if (
    !(
      permissions.includes("assessments.read") ||
      permissions.includes("assessments.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  return (
    <Show {...props}>
      <QuestionShowInner />
    </Show>
  );
};

export default QuestionShow;